import React from 'react';
export function Women() {
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-555">
      <div className="max-w-[1800px] mx-auto" data-id="element-556">
        <header className="mb-20 text-center" data-id="element-557">
          <span className="text-[10px] font-display uppercase tracking-[0.5em] mb-4 block text-black/40" data-id="element-558">
            Feminine Heritage
          </span>
          <h1 className="text-4xl md:text-6xl font-display font-bold tracking-[0.2em] uppercase mb-6" data-id="element-559">
            Women
          </h1>
          <p className="max-w-xl mx-auto text-sm font-light tracking-widest text-black/60 leading-relaxed uppercase" data-id="element-560">
            Graceful silhouettes and intricate patterns designed for the modern
            woman.
          </p>
        </header>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-561">
          {['https://cdn.magicpatterns.com/uploads/bMzdmqtiahnnmMbnKaQtb9/image.png', 'https://cdn.magicpatterns.com/uploads/pyPQ371b8FAGqP4T9JAg1g/image.png', 'https://cdn.magicpatterns.com/uploads/d353YWp21zZqnC3Pek7CAu/image.png'].map((img, i) => <div key={i} className="group cursor-pointer" data-id="element-562">
              <div className="aspect-[3/4] bg-grey-divider overflow-hidden mb-6" data-id="element-563">
                <img src={img} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" alt="Womenswear" data-id="element-564" />
              </div>
              <h3 className="text-[11px] font-display font-bold tracking-widest uppercase" data-id="element-565">
                Womenswear Look {i + 1}
              </h3>
            </div>)}
        </div>
      </div>
    </div>;
}